import './InlineInputForm.scss';
import classNames from 'classnames';
import { haltClickEventPropagation } from '@lib/events';
import { OutsideClickWrapper } from '@ui/general';
import { Rule } from 'antd/es/form/index';
import { Button, ButtonProps, Form, Input, InputProps, Space } from 'antd';
import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import React, { useState } from 'react';

export interface InlineInputFormProps {
	cancelProps?: ButtonProps;
	className?: string;
	confirmProps?: ButtonProps;
	currentValue?: string;
	inputProps?: InputProps;
	maxLength?: number;
	noPadding?: boolean;
	onCancel: () => void;
	onSubmit: (value: string) => void;
	processing?: boolean;
	wrapperProps?: { className?: string; id?: string };
}

const baseRules: Array<Rule> = [
	{
		required: true
	}
];

export const InlineInputForm: React.FC<InlineInputFormProps> = ({
	cancelProps,
	className,
	confirmProps,
	currentValue,
	inputProps,
	maxLength,
	noPadding,
	onCancel,
	onSubmit,
	processing,
	wrapperProps
}) => {
	const [ value, setValue ] = useState(currentValue);
	const [ form ] = Form.useForm<{ value: string }>();

	const rules = maxLength ? [ ...baseRules, { max: maxLength } ] : baseRules;

	return (
		<OutsideClickWrapper
			onClick={ haltClickEventPropagation }
			onClickOutside={ onCancel }
			{ ...wrapperProps }>
			<Form
				className={ classNames('inline-input-form', { 'no-padding': noPadding }, className) }
				form={ form }
				layout='inline'
				onFinish={ (values) => onSubmit(values.value?.trim()) }>
				<Space size={ 2 }>
					<Form.Item
						initialValue={ currentValue }
						name='value'
						noStyle
						rules={ rules }>
						<Input
							id={ currentValue ? 'edit-input' : 'create-input' }
							{ ...inputProps }
							autoFocus
							maxLength={ maxLength }
							onChange={ (e) => setValue(e.target.value) }
							onPressEnter={ (e) => {
								e.preventDefault();
								e.stopPropagation();
								form.submit();
							} } />
					</Form.Item>
					<Button
						id={ currentValue ? 'edit-confirm' : 'create-confirm' }
						{ ...confirmProps }
						disabled={ !value }
						htmlType='submit'
						icon={ <PlusOutlined /> }
						loading={ processing }
						type='primary' />
					<Button
						id={ currentValue ? 'edit-view-cancel' : 'create-view-cancel' }
						{ ...cancelProps }
						danger
						disabled={ processing }
						ghost
						htmlType='reset'
						icon={ <CloseOutlined /> }
						onClick={ onCancel } />
				</Space>
			</Form>
		</OutsideClickWrapper>
	);
};
